<template>
	<div>
		<ul class="config-list ">
			<li class="dpB_E">
				<label for="COMPUTE">
					{{getLanguageStr('plant324','实际自发自用比例')}}
					<div>
						<input type="radio" name="proportion" id="COMPUTE" value="COMPUTE" v-model="requestData.consumeProportionStatisticMethod">
						<span class="fa fa-check-circle"></span>
					</div>
				</label>
			</li>
			<li class="dpB_E">
				<label for="theory">
					{{getLanguageStr('plant325','理论自发自用比例')}}
					<div>
						<input type="radio" name="proportion" id="theory" value="THEORY" v-model="requestData.consumeProportionStatisticMethod">
						<span class="fa fa-check-circle"></span>
					</div>
				</label>
			</li>
		</ul>
		<div class="taC">
			<button class="functionBtn w8x mt6x" type="button" @click="saveSetting">{{$t('cmd84',['保存'])}}</button>
		</div>
	</div>
</template>
<script>
import { mapGetters} from 'vuex'
import * as lib from "@/util/lib"
import Loading from '@/components/common/ui/Loading'

import {getLanguageStr} from "@/util/language"
import * as configApi from '@/api/maintain/config'

export default {
	name: 'stationProportionConfig',
	props: {
		// req: {
		// 	type: Object,
		// 	default: () => ({})
		// },
	},
	components:{
		Loading,
	},
	computed:{
		...mapGetters({
			stationId: 'stationDetail/stationId',
			metering:'stationDetail/metering'
		})
	},
	data(){
		return{
			requestData:""
		}
	},
	methods:{
		getLanguageStr,
		reset(){
			this.requestData=_.cloneDeep(this.metering)
		},
		saveSetting(){
			let request={
				source:this.requestData.consumeProportionStatisticMethod
			}
			configApi.consumptionSource(this.stationId,request).then(res=>{
				this.$emit('refresh')
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		}
	}
}

</script>
<style lang="scss" scoped>
.config-list{
	li{
		padding-left:1.5em;
		height:3em;
		font-size: 1.2em;
		line-height: 3em;
		border-bottom:1px solid rgba(0, 0, 0, 0.1);
		cursor: pointer;
		position: relative;
		div{
			float:right;
			height: 100%;
			margin-right: 3em;
			input[type="radio"]{
				appearance: none; 
				-webkit-appearance: none;
				outline: none;
				display:none;
			}
			input[type="radio"] + span{
				display: none
			}
			input[type="radio"]:checked + span{
				display:inline-block;
				font-size: 1.4em;
				color:#FF7020;
			}
		}
	
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationProportionConfig.vue